import { render, staticRenderFns } from "./AddEventPage.vue?vue&type=template&id=af843f4c&scoped=true&"
import script from "./AddEventPage.vue?vue&type=script&lang=js&"
export * from "./AddEventPage.vue?vue&type=script&lang=js&"
import style0 from "./AddEventPage.vue?vue&type=style&index=0&id=af843f4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af843f4c",
  null
  
)

export default component.exports